// extracted by mini-css-extract-plugin
module.exports = {"center":"LoadingHub_center__1WkOk","backdrop":"LoadingHub_backdrop__YojO2"};